export const getSoftLimitWarning = (
  softLimit,
  value,
  hasError = false,
  returnWarning = true,
  warningMessage = "Manager approval required",
) => {
  if (!softLimit) return false;

  if (hasError) return false;

  if (value === "" || value === null || value === undefined) return false;

  const softLimitBreached =
    !isNaN(parseFloat(value)) &&
    !isNaN(parseFloat(softLimit)) &&
    parseFloat(value) <= parseFloat(softLimit);

  if (returnWarning && softLimitBreached) {
    const limitNum = parseFloat(softLimit);
    const formatted = Number.isInteger(limitNum) ? String(limitNum) : limitNum.toFixed(2);
    return `${warningMessage} (soft limit: ${formatted})`;
  }

  return softLimitBreached;
};
